import { useTranslation } from '@/locales';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { RiskSimulatorHeaderPermitted } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/RiskSimulatorHeader/RiskSimulatorHeaderPermitted';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';

export const RiskSimulatorHeader = () => {
  const { t } = useTranslation('riskSimulator');
  const { shouldDisplayModeling } = usePermissionsManager();
  const { isDesktop } = useBreakpointsCtx();

  if (!shouldDisplayModeling) {
    return (
      <StyledHeader position="static" isDesktop={isDesktop}>
        <StyledBasicToolbar>
          <StyledAgioH1
            noWrap
            color="customSecondary.primary.DEFAULT"
            data-testid="risk-simulator-header-title"
          >
            {t('risk-simulator.header.title')}
          </StyledAgioH1>
        </StyledBasicToolbar>
      </StyledHeader>
    );
  }

  return <RiskSimulatorHeaderPermitted />;
};
